const Footer = () => (
  <div className="fixed bottom-[10px] z-50 text-center dark:text-white-dark sm:text-left">
    © {new Date().getFullYear()}. Courierboost All rights reserved.
  </div>
);

export default Footer;
